(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["canard-contact-form"] && !Shopify.designMode) return;
  try {
    (() => {
    const inquirySelect = document.getElementById('ContactForm-inquiry-type')
    const orderNumberWrapper = document.getElementById('ContactForm-order-number-wrapper')
    const orderNumberInput = document.getElementById('ContactForm-order-number')

    if (!inquirySelect || !orderNumberWrapper || !orderNumberInput) return

    const toggleOrderNumberField = () => {
      const showOrderNumber = inquirySelect.value === 'Order Inquiry'
      orderNumberWrapper.hidden = !showOrderNumber
      orderNumberInput.disabled = !showOrderNumber
      orderNumberInput.required = showOrderNumber

      if (!showOrderNumber) orderNumberInput.value = ''
    }

    inquirySelect.addEventListener('change', toggleOrderNumberField)
    toggleOrderNumberField()
  })()
  } catch(e) { console.error(e); }
})();

})();
